<template>
  <div id="page-request" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <div class="page-request py-3">
        <div class="content-loader" v-if="loadingH">
          <!--div id="loader"></div-->
          <div id="loader2"></div>
          <div class="cssload-dots">
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
          </div>
        </div>
        <!--div class="container"-->
        <p class="mb-4 ml-4" v-if="id == null">
          <span class="titulo-pagina">Historial de reportes
          </span>
          <span class="subtitulo-pagina"></span>
        </p>
        <div class="row mb-3">
          <!--div class="col-md-3">
              <h2 style="color: #263238">Historial de reportes</h2>
            </div-->
          <div class="d-flex flex-row col-12">
            <div class="col col-md-3 pl-4 pr-0">
              <b-button pill class="text-center button-danger pl-4 ml-0" size="lg" variant="outline-danger" style=" border: none;width: 169px; 
                " @click="limpiar()">
                Quitar todos los filtros

              </b-button>
            </div>
            <div class="col col-md-9 p-0">
              <button class="button-secundary rounded-pill mt-4 " v-b-toggle.accordion-1 variant="light" style="margin-left: auto;
margin-bottom: 10px;
margin-right: 0px;
position: realtive;
width: 121px;
height: 40px;
border-radius: 100px;">
                <span class="when-opened">
                  Filtros
                  <img class=" pl-0" src="@/assets/images/icons/filter.svg">
                </span>
                <span class="when-closed">
                  Filtros
                  <img class=" pl-0" src="@/assets/images/icons/filter.svg">
                </span>
              </button>
            </div>
          </div>
         
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-collapse id="accordion-1" class="filtros" accordion="my-accordion" role="tabpanel" align="left">
              <b-card-body class=" mb-3 tab-filtros2">

                <div class="row" style="flex-wrap:inherit;margin-right: 0px;">
                  <div class="col-md-4 pl-8" style="margin-left: 16px">
                    <span class="cta ml-8" style="color: #5d5fef">Fecha</span>
                    <div class="linea"></div>
                    <b-form-datepicker locale="es" v-model="fechaIni" size="lg" class="mb-1 data_picker"
                      :max="fechaFin"></b-form-datepicker>
                    <b-form-datepicker locale="es" v-model="fechaFin" size="lg" class="mb-1 data_picker"
                      :min="fechaIni"></b-form-datepicker>
                  </div>

                  <div class="col-md-4 ml-0">
                    <span class="cta" style="color: #5d5fef">Estado</span>
                    <div class="linea">
                      <div class="m-3">
                        <input v-model="estado" type="checkbox" @change="obtenerDatatableFilter(1)" id="checkbox-1"
                          name="checkbox-1" value="1">
                        <label for="checkbox-1">
                          <img class="leftImg1 mr-3" src="@/assets/images/icons/pendiente.svg">
                        </label>
                      </div>
                      <div class="m-3">
                        <input v-model="estado" type="checkbox" @change="obtenerDatatableFilter(1)" id="checkbox-2"
                          name="checkbox-2" value="2">
                        <label for="checkbox-2">
                          <img class="leftImg1 mr-3" src="@/assets/images/icons/cerrado.svg">
                        </label>
                      </div>
                   </div>
                  </div>
                  <div class="col-4">
                    <img class="rightImg1" src="@/assets/images/onboarding/add_information.svg" />
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="ml-4 mt-2 mb-1 mr-0">
              <datatable :columns="datatable.columns" :data="datatable.rows" :filter="datatable.filter"
                :per-page="datatable.perPage" :page="datatable.page" class="table table-hover table-borderless "
                id="my-table">
                <template slot-scope="{ row, columns }">
                  <tr @dblclick="verRegistro(row)" v-b-tooltip.hover :title="row.diasHabileTxt">
                    <template>
                      <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row"
                        class="cell-border">
                      </datatable-cell>
                    </template>
                  </tr>
                </template>
              </datatable>
              <div class="col-12">
                <b-pagination class=" col-12
                        pagination_light
                        my-5
                        d-flex
                        justify-content-center"
                        align="center" v-model="pagina" :total-rows="datatable.total"
                  :per-page="datatable.per_page" aria-controls="my-table"></b-pagination>
                <!-- <div  class="col-12 cont-pagination my-5 d-flex justify-content-center" >
              <Pagination
                :data="datatable"
                :limit="10"
                @pagination-change-page="getPdv"
              >
                <template #prev-nav>
                  <span>&lt;</span>
                </template>
                <template #next-nav>
                  <span>&gt;</span>
                </template>
              </Pagination> -->

              </div>
       
              <!--div class="cont-no-data" v-show="datatable.rows.length <= 0">
                  <div class="col-12 col-md-8 col-lg-7 mx-auto mt-3">
                    <img src="@/assets/images/demands/user-mail.svg" alt="user email" width="100%" />
                  </div>
                </div-->
            </div>
          </div>
          <!-- .row -->
        </div>
        <!-- .layout-content -->
        <!--/div-->
      </div>
    </div>
  </div>

  <!-- #page-request -->
</template>

<script>
//import TemplateLetter from "./TemplateLetter.vue";
//import Pagination from "laravel-vue-pagination";
import  "@/assets/scss/components/tables.scss";
import HeadingUser from "@/components/user/HeadingUser.vue";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import EstadoNovedad from "@/components/datatables/EstadoNovedad.vue";
import { mapActions, mapState } from "vuex";
import serverConfig from "../../services/config";

export default {
  name: "tipsreporthistory",
  components: {
   // Pagination,
    MainBarMenuV2,
    //TemplateLetter,
    HeadingUser,
  },
  data() {
    return {
      fechaIni: null,
      fechaFin: null,
      estado: [],
      pagina: null,
      pdv_name: null,
      tooltips: null,

      // Listado de turnos
      datatable: {
        filter: "",
        total: 18,
        per_page: 10,
        page: 1,
        last_page: 2,
        columns: [
          {
            label: "Fecha",
            field: "fecha",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "PDV",
            field: "points_sale.name",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "Código",
            field: "points_sale.code",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "Novedades",
            field: "novedades",
            align: "left",
            headerClass: "text-left table-th",
          },
          {
            label: "Estado de novedad",
            field: "estado_novedades",
            align: "right",
            headerClass: "text-right table-th",
            component: EstadoNovedad,
          },
        ],
        rows: [],
      },

      selected: [], // Must be an array reference!
      checked: false,
      text: "",
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
    };
  },

  watch: {
    pagina: function (pagina) {
      this.obtenerDatatable(pagina);
    },
  },

  beforeMount() {
    // obtener pdv
    this.pagina = 1;
    this.getPdv();
  },
  computed: {
    ...mapState("modCore", ["user", "userData"]),
    ...mapState("modTipshiftReportHistory", ["turnos", "loadingH"]),
  },

  methods: {
    ...mapActions("modRequest", ["actGetSettings"]),

    ...mapActions("modTipshiftReportHistory", ["actGetTurnos"]),

    ...mapActions("modTipshiftPointSale", [
      "actGetDatatable",
      "actSavePdvEscenarios",
      "actGetIndex",
    ]),

    obtenerDatatable(pagina = 1) {
      this.pagina = pagina;
      let data = [];
      let status = [];
      if (this.estado[0] == null) status = [1, 2];
      else status = this.estado;
      data = {
        fecha_inicio: this.fechaIni,
        fecha_fin: this.fechaFin,
        // estado: this.estado == [] ? this.estado : [this.estado],
        estado: status,
        //estado: this.estado,
        pdv: this.pdv_name,
        page: this.pagina,
        filter: this.datatable.filter,
      };



      this.actGetTurnos(data)
        .then((response) => {
          this.actualizarTabla(response);
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo conectar al servicio: error: " + response;
        });
    },

    obtenerDatatableFilter(status) {
      this.pagina = 1;
      this.obtenerDatatable(status);
      console.log("datos1", this.estado);
    },

    limpiar() {
      //this.escenario = [];
      //this.bodegaSelected = null;
      this.pagina = 1;
      (this.fechaIni = null),
        (this.fechaFin = null),
        (this.estado = []),
        (this.pagina = null),
        this.obtenerDatatable(this.pagina);
    },

    getPdv() {
      // Obtener la cargar de la página
      //this.actGetIndex();
      // Obtener el listado de turnos
      this.obtenerDatatable(this.pagina);
      // let data = [];
      // data = {
      //   page: this.datatable.page,
      //   type_list_id: this.typeOfList.hostorial,
      // };

      // this.actSelectOptions(data).then(() => {
      //   if (this.hostorial.data.data) {
      //     this.hostorial.data.data.forEach((x) => {
      //       this.datatable.rows.push({
      //         id: x.id,
      //         code: x.code,
      //         name: x.name,
      //       });
      //     });
      //   }
      // });
      // this.loadRows();

    },
    // loadRows() {
    //   this.datatable = {
    //     total: 18,
    //     perPage: 10,
    //     last_page: 2,
    //     page: 1,
    //     columns: [],
    //     rows: [],
    //   };
    //   this.datatable.columns = [

    //   ];
    // },
    verRegistro(row) {
      this.$router.push({
        path:
          "/tipsreporthistory/" +
          row.id +
          "/" +
          row.fecha +
          "/" +
          row.pro_point_sale_id,
      });
    },

    actualizarTabla(response) {
      this.datatable.rows = response.data.data;
      this.datatable.last_page = response.data.last_page;
      this.datatable.per_page = response.data.per_page;
      this.datatable.total = response.data.total;
    },

    getFilterAdv(page = 1) {
      let data = [];
      data = {
        type: this.oneDay,
        fecha_inicio: this.fechaIni,
        fecha_fin: this.fechaFin,
        estado: this.estado == null ? this.estado : [this.estado],
        page: page,
        filter: this.datatable.filter,
      };

      console.log(page, data);

      this.actGetTurnos(data)
        .then((response) => {
          this.datatable.rows = response.data.data;
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo conectar al servicio: error: " + response;
        });
    },

    /*getFilterEstado(a,b){
      console.log(a,b);
    },*/
  },
};
</script>

<style lang="scss" scoped>
//@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');


.page-request {
  .custom-control-input:checked~.custom-control-label::before {
    content: "\02713" !important;
  }

  .page-item.active .page-link {
    color: #fff !important;
    background-color: red !important;
    border-color: #1c6776 !important;
  }

  .page-link {
    color: blue !important;
  }

  /*.table {
    width: 1002px;
    margin-bottom: 1rem;
    color: #212529;
  }
  .table tbody tr td {
    font-size: 14px;
    color: #454545;
  }*/

  .title-3 {
    font-size: 24px;
    font-weight: bold;
    color: #1c3a4e;
  }

  .cont-request-text {
    .cont-title {
      color: #1c3a4e;

      .title-1 {
        font-size: 40px;
        font-weight: bold;
      }

      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }

    .form-request {
      .button2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 100px;
        height: 42px;
        width: 220px;
        font-size: 14px;
        text-align: center !important;
        padding-left: 2%;
        padding-right: 2%;

        &:hover {
          background: darken(#7a7c7e, 5);
        }

        .button3 {
          border-radius: 50px;
          font-family: "Open Sans";
          color: #1c3a4e;
          font-size: 20px;
          border: 0 none;
          outline: none;
          text-decoration: none;
          border: 2px solid #1c3a4e;
        }
      }
    }
  }

  .p1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
  }

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    //color: #979494;
    text-align: center !important;
  }

  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #999797;
  }

  .center {
    display: flex;
    align-items: center;
  }

  .button4 {
    background: #99a6af;
    color: #ffffff;
    border-radius: 8px;
    height: 20px;
    font-size: 8px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;

    &:hover {
      background: darken(#99a6af, 5);
    }
  }

  .collapsed>.when-opened,
  :not(.collapsed)>.when-closed {
    display: none;
  }

  .centerImg2 {
    vertical-align: middle;
    position: relative;
    bottom: 2px;
    padding-right: 2%;
  }

  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }

  .mycheck {
    width: 1.3em;
    height: 1.3em;

    border-radius: 30%;
    vertical-align: middle;
    border: 1px solid #ddd;
    //-webkit-appearance: none;
  }

  .mycheck:checked {
    background-color: #1c3a4e;
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked+.slider {
    background-color: #779b49;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #779b49;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .style-filter .vs__search::placeholder,
  .style-filter .vs__dropdown-toggle,
  .style-filter .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
    font-size: 11px;
    line-height: 12px;
  }

  .style-filter .vs__clear,
  .style-filter .vs__open-indicator {
    fill: #394066;
  }

  /* Center the loader */
  #loader {
    position: relative;
    z-index: 1072;
    left: 50%;
    top: 50%;
    z-index: 1;

    margin: -75px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  .content-loader {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1071;
    background-color: #fff;
    opacity: 0.9;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }

  .nav-item {
    text-decoration-color: #1c6776 !important;
    border-left-color: #1c6776 !important;
    border-left-width: thick !important;
    background-color: rgba(0, 0, 0, 0.03) !important;
  }

  .card-header {
    background-color: none !important;
  }

  .card {
    background-color: none !important;
    border-color: none !important;
    border: 0px !important;
  }

  .cont-search {
    label {
      font-size: 11px;
      color: #454545;
    }

    .cont-input {
      background: #1c3a4e;
      border-radius: 4px;
      padding: 1px;
      width: fit-content;
      float: left;

      .input-text {
        padding: 8px;
        min-width: 160px;
        border-radius: 4px;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        color: #bbbbbb;
        border: 0 none;

        &:focus {
          outline: none;
        }
      }

      button {
        background: transparent;
        border: 0 none;
        color: #ffffff;
      }

      @media (min-width: 768px) {
        float: right;
      }
    }
  }

  a:hover,
  a:focus,
  a:active {
    text-decoration: none;
    color: inherit;
  }

  .button1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 7px 10px;
    margin-left: auto;
    margin-bottom: 10px;
    position: realtive;
    width: 121px;
    height: 40px;

    /* Neutral / White */

    background: #ffffff;
    /* Primary / 3 */
    //color: #269887;
    //border: 2px solid #269887;
    box-sizing: border-box;
    border-radius: 100px;
  }

  .div1 {
    border: 0px solid black;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 40px;
    margin-left: 40px;
  }

  .tabla1 {
    border-radius: 5px;
    border: 3px solid #e9ecee;
    border-color: #e9ecee;
    background: #e9ecee;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    padding-left: 5%;
    align-self: left;
  }

  .td1 {
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    padding-left: 0%;
    padding-right: 3%;
    text-align: left;
  }

  .td2 {
    background: #e9ecee;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 14px;
    text-align: left;
    padding-left: 4%;
    padding-right: 4%;
  }

  .td3 {
    background: #ffffff;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 40px;
    //width: 50px;
    text-align: left;
    padding-left: 4%;
    padding-right: 4%;
  }

  .td4 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    //font-weight: bold;
    font-size: 12px;
    line-height: 25px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: left;
  }

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    //font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    //color: #454545;
    text-align: left !important;
  }

  .collapsed>.when-opened,
  :not(.collapsed)>.when-closed {
    display: none;
  }

  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    margin-top: 2px;
    margin-right: 10px;
    float: right;
  }

  .leftImg1 {
    //width: 16px;
    //height: 16px;
    vertical-align: middle;
    // margin-top: 24px;
    margin-left: 50px;
  }

  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }

  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }

  @media only screen and (max-width: 600px) {
    .td2 {
      width: 33%;
    }
  }

  .tab-filtros {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Neutral / Gray 3 */
    border: 1px solid #dddddd;
    box-sizing: border-box;
    /* up leve */
    box-shadow: 0px 8px 8px rgba(110, 116, 134, 0.16);
    border-radius: 8px;
  }

}

.filtros-open {
  width: 1002px;
}

.filtros {
  display: flex;

  height: 216px;
  margin-left: 15px;
  margin-bottom: 24px;

  flex-direction: column;

  /* content/00 */

  background: #ffffff;
  /* Bottom */

  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14);
  border-radius: 12px;
}

.linea {
  //padding: 15px 5px;
  margin-top: 10px;
  border-top: 1px solid #cfd8dc;
  -o-border-image: linear-gradient(to right,
      rgba(66, 87, 119, 0) 5%,
      #cfd8dc 5%,
      #cfd8dc 95%,
      rgba(66, 87, 119, 0) 95%);
  border-image: linear-gradient(to right,
      rgba(66, 87, 119, 0) 5%,
      #cfd8dc 5%,
      #cfd8dc 95%,
      rgba(66, 87, 119, 0) 95%);
  border-image-slice: 1;
}

.data_picker {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px !important;

  position: relative;
  height: 44px !important;
  left: 0px;
  right: 0px;
  //top: 8px;

  /* content/00 */

  background: #ffffff !important;
  /* content/03 */

  border: 1px solid #b0bec5 !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
  margin-bottom: 16px !important;
  margin-top: 16px !important;
  float: right;

  button {
    position: absolute;
    right: inherit;
  }
}

input[type="checkbox"]+label {
  margin-left: 0px !important;
  margin-top: 20px !important;
}

.rightImg1 {
  position: absolute;
  right: 0;
  top: -12px;
  border-radius: 16px;
  height: 216px;
}

.table-th {
  height: 53px !important;
  vertical-align: middle !important;
}

.table>tbody>tr>td {
  //border: none !important;
  border-right: #cfd8dc solid 1px;
  border-spacing: 1 !important;
}

/* remove border from first tbody row... */
.table>tbody>tr:first-child>td,
.table>tbody>tr:first-child>th {
  border-top: none;
  height: 53px !important;
  vertical-align: middle !important;
}


input[type="checkbox"] {
  display: none;


}

input[type="checkbox"]+label {

  margin-left: 25px;

}

input[ type=checkbox]+label:before {
  content: "";
  display: inline-block;


  width: 20px;
  height: 20px;


  border: 1px solid #7A7CFF;
  box-sizing: border-box;
  border-radius: 2px;
  text-align: center;
  vertical-align: text-top;
  line-height: 15px;
  margin: 3px 12px -3px 1px;
  padding: 0px;
  position: realtive;
  left: 28px;

}

input[ type=checkbox]:checked+label:before {
  content: "\02713";
  //font-size:10px;
  background: #5D5FEF;
  border-radius: 2px;
  color: #fff;

}

input[ type=checkbox]:focus+label:before {
  box-shadow: 0px 0px 3px 1px #ccc;
}

input[ type=checkbox]:hover+label:before {
  box-shadow: 0px 0px 4px #5D5FEF;
}


.pagination{
  color: red !important;

  .page-item.active .page-link {
    color: #fff !important;
    background-color:red !important;
    border-color: blue !important;
  }

  button.page-link {
    color: red !important;
  }
}

li button.page-link>.pagination {
  color: red !important;
}
</style>
<style >


.pagination .page-item.active .page-link {
   /* color: #fff !important;*/
    background-color: #e9ecef !important;
    border-color: #dee2e6 !important;
  }

  .pagination  button.page-link {
    color: #eceff1  !important;
  }


li button.page-link>.pagination {
  color: #eceff1 !important;
}
</style>